import React from "react"
import { Section, ValuePropositionMainContent } from "@alexanderathoodly/ui-library"
import { CommonBlockProps } from "../types"
import { BlockFooter } from "../blockfooter"
import { getIconPath } from "../../helpers/getIconPath"

type Proposition = {
    icon: string
    name: string
    label: string
    headline: string
    description: string
    illustration: string
}

export interface VpProps extends CommonBlockProps {
    template: "propositions"
    propositions: Proposition[]
}

const ValuePropositions = ({
    id,
    color,
    icon = "wand",
    label,
    headline,
    propositions,
    buttons,
    footertext,
    ...rest
}: VpProps): JSX.Element => {
    return (
        <Section
            id={id || undefined}
            className="propositions-section"
            shape="shape3"
            backgroundColor={color}
            icon={getIconPath(icon)}
            label={label}
            headline={headline}
            {...rest}
        >
            {propositions && propositions.length > 0 && (
                <ValuePropositionMainContent
                    propositions={propositions.map((p) => ({
                        ...p,
                        icon: getIconPath(p.icon),
                    }))}
                />
            )}
            <BlockFooter footertext={footertext} buttons={buttons} position={headline} />
        </Section>
    )
}

export { ValuePropositions }
